import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useEffect, useState } from 'react';

export function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading, checkAuth, setUser } = useAuth();
  const location = useLocation();
  const userFromState = location.state?.user;
  
  // If we have user from state but not in context yet, we're setting up
  const isSettingUpUser = userFromState && !user;
  
  const [hasSetUser, setHasSetUser] = useState(false);

  useEffect(() => {
    // If user data passed from AuthCallback, update AuthContext immediately
    if (userFromState && !user && !hasSetUser) {
      setHasSetUser(true);
      setUser(userFromState);
      return;
    }
    
    // If user already in context, don't check again
    if (user) {
      return;
    }
    
    // Only verify if loading is complete and no user from state
    if (!loading && !user && !userFromState) {
      checkAuth().catch((error) => {
        console.error('Auth check failed:', error);
      });
    }
  }, [userFromState, user, loading, checkAuth, setUser, hasSetUser]);

  // Show loading while setting up user from OAuth callback
  if (isSettingUpUser) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-[#52525B]">Setting up your session...</div>
      </div>
    );
  }

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-[#52525B]">Loading...</div>
      </div>
    );
  }

  // Check if we have a user in context
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role permissions
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
